var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: { "mask-closable": false, width: "450", closable: false },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c("div", { staticClass: "modalhead" }, [
        _c("div", {}, [_vm._v(_vm._s(_vm.$t("components.global.flowDetail")))]),
        _c("div", { staticClass: "secondTitle" }, [
          _vm._v(
            _vm._s(_vm.$t("components.global.flowId")) +
              ": " +
              _vm._s(_vm.detailList.fundFlowId)
          ),
        ]),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [
            _vm._v(_vm._s(_vm.$t("components.global.businessType")) + ": "),
          ]),
          _c("div", { staticClass: "fr" }, [
            _vm._v(
              _vm._s(
                this.$filters.getFondTypeName(
                  _vm.detailList.fundType,
                  _vm.locales
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "line" }, [
          _vm.detailList.transactionType === "REFUND"
            ? _c("div", { staticClass: "fl" }, [
                _vm._v(_vm._s(_vm.$t("components.global.inComingTime")) + ":"),
              ])
            : _c("div", { staticClass: "fl" }, [
                _vm._v(_vm._s(_vm.$t("components.global.recordedTime"))),
              ]),
          _c("div", { staticClass: "fr" }, [
            _vm._v(
              _vm._s(this.$filters.timestampToDatetime(_vm.detailList.created))
            ),
          ]),
        ]),
        _c("div", { staticClass: "line" }, [
          _vm.detailList.transactionType === "REFUND"
            ? _c("div", { staticClass: "fl" }, [
                _vm._v(_vm._s(_vm.$t("components.global.orderOriginAmount"))),
              ])
            : _c("div", { staticClass: "fl" }, [
                _vm._v(_vm._s(_vm.$t("components.global.orderOriginAmount"))),
              ]),
          _c("div", { staticClass: "fr" }, [
            _vm._v(
              _vm._s(_vm.detailList.originalAmount) +
                " " +
                _vm._s(_vm.detailList.originalCurrency)
            ),
          ]),
        ]),
        _vm.detailList.originalCurrency != _vm.detailList.currency
          ? _c("div", { staticClass: "line" }, [
              _c("div", { staticClass: "fl" }, [
                _vm._v(_vm._s(_vm.$t("components.global.exchangeRate"))),
              ]),
              _c("div", { staticClass: "fr" }, [
                _vm._v(
                  "1 " +
                    _vm._s(_vm.detailList.originalCurrency) +
                    "=" +
                    _vm._s(_vm.detailList.fxRate) +
                    " " +
                    _vm._s(_vm.detailList.currency)
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "line" }, [
          _vm.detailList.transactionType === "REFUND"
            ? _c("div", { staticClass: "fl" }, [
                _vm._v(_vm._s(_vm.$t("components.global.refundAmount"))),
              ])
            : _c("div", { staticClass: "fl" }, [
                _vm._v(_vm._s(_vm.$t("components.global.recordedAmount"))),
              ]),
          _vm.detailList.transactionType === "REFUND"
            ? _c("div", { staticClass: "fr" }, [
                _vm._v(
                  _vm._s(_vm.detailList.debitAmount) +
                    " " +
                    _vm._s(_vm.detailList.currency)
                ),
              ])
            : _c("div", { staticClass: "fr" }, [
                _vm._v(
                  _vm._s(_vm.detailList.creditAmount) +
                    " " +
                    _vm._s(_vm.detailList.currency)
                ),
              ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "textright", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "pp-button",
            {
              staticClass: "modal-btn",
              attrs: { type: "primary", size: "spec" },
              on: { click: _vm.sure },
            },
            [_vm._v(_vm._s(_vm.$t("components.global.confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }